import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import Home from "./Page/Home/HomePage";
import About from "./Page/About/AboutPage";
import Contact from "./Page/Contact/ContactPage";
// import Sustainability from "./Page/Sustainability/SustainabilityPage";
import Packaging from "./Page/Packaging/Packaging";


/* Product Sections */
import DrinkWater from "./Page/Products/DrinkWater/DrinkWater";
import Fireproof from "./Page/Products/Fireproof/Fireproof";
import Sealing from "./Page/Products/Sealing/Sealing";
import Special from "./Page/Products/Special/Special";
import Vibration from "./Page/Products/Vibration/Vibration";
/* Technologies Sections*/
import Automation from "./Page/Technologies/Automation/Automation";
import Material from "./Page/Technologies/Material/Material";
import MixingProcess from "./Page/Technologies/MixingProcess/MixingProcess";
/* Quality Sections */
import QualityControl from "./Page/Quality/QualityControl/QualityControl";
import QualitAssurance from "./Page/Quality/QualityAssurance/QualityAssurance";

function App() {
  const location = useLocation();
  return (
    <div className="App">
      <Navbar location={location.pathname}/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/drinkwater" element={<DrinkWater />} />
        <Route path="/fireproof" element={<Fireproof />} />
        <Route path="/sealing" element={<Sealing />} />
        <Route path="/special" element={<Special />} />
        <Route path="/vibration" element={<Vibration />} />
        <Route path="/packaging" element={<Packaging />} />
        <Route path="/automation" element={<Automation/>} />
        <Route path="/material" element={<Material/>} />
        <Route path="/mixingprocess" element={<MixingProcess/>} />
        <Route path="/qualitycontrol" element={<QualityControl/>} />
        <Route path="/qualitassurance" element={<QualitAssurance/>} />
        {/* <Route path="/sustainability" element={<Sustainability />} /> */}
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer location={location.pathname} />
    </div>
  );
}

export default App;
